import React from 'react';
import { ModalOffset } from '@blueprint/ui';

import { Modals, ModalManagerProps } from './ModalManager.types';

import { SearchInitiationMobileModal } from '../SearchInitiationMobileModal';
import { ContentWrapper } from './ModalManager.styles';

export const MODALS: Modals = {
    search_initiation: {
        content: SearchInitiationMobileModal,
        type: ModalOffset
    }
};

export const ModalManager = ({
    modalType,
    modalProps,
    isModalShowing,
    closeModal
}: ModalManagerProps) => {
    if (!modalType) {
        return null;
    }

    const { type: Wrapper, content: Content } = MODALS[modalType];

    return (
        <Wrapper isShowing={isModalShowing} close={closeModal}>
            <ContentWrapper>
                <Content close={closeModal} {...modalProps} />
            </ContentWrapper>
        </Wrapper>
    );
};
